import { usePaginatedCollections } from 'lib-knowledge-management-common/hooks/usePaginatedCollections';
import { useMemo } from 'react';

export type CollectionOption = { id: string; name: string };

/**
 * Collections a draft can be filed into, in the shape habla's selects take.
 *
 * Elevio-synced collections are left out: they are managed in Elevio and cannot
 * take an article, so approving into one would fail.
 */
export function useCollections(): {
  collections: CollectionOption[];
  loading: boolean;
  hasMore: boolean;
  fetchNextPage: () => Promise<void>;
} {
  const { data, loading, hasMore, fetchNextPage } = usePaginatedCollections();

  const results = data?.collections.results;

  const collections = useMemo(
    () =>
      (results ?? [])
        .filter((collection) => !collection.isSyncedWithElevio)
        .map((collection) => ({ id: collection.id, name: collection.title })),
    [results],
  );

  return { collections, loading, hasMore, fetchNextPage };
}
